import { render, staticRenderFns } from "./SpeedTest.vue?vue&type=template&id=3d63353e&"
import script from "XY/components/speedTest/speedTest.component?vue&type=script&lang=js&"
export * from "XY/components/speedTest/speedTest.component?vue&type=script&lang=js&"
import style0 from "./SpeedTest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports